if (!customElements.get('p4p-sale-window')) {
  customElements.define('p4p-sale-window', class extends HTMLElement {
    constructor() {
      super();
      this.syncState = this.syncState.bind(this);
    }

    connectedCallback() {
      this.syncState();
      document.addEventListener('visibilitychange', this.syncState);
      window.addEventListener('pageshow', this.syncState);
    }

    disconnectedCallback() {
      clearTimeout(this.expiryTimer);
      document.removeEventListener('visibilitychange', this.syncState);
      window.removeEventListener('pageshow', this.syncState);
    }

    syncState() {
      clearTimeout(this.expiryTimer);
      const startsAt = Date.parse(this.dataset.startsAt);
      const endsAt = Date.parse(this.dataset.endsAt);
      const now = Date.now();
      const active = now >= startsAt && now < endsAt;
      this.querySelectorAll(':scope > [data-p4p-sale-state]').forEach((content) => {
        content.hidden = (content.dataset.p4pSaleState === 'active') !== active;
      });
      const nextChange = now < startsAt ? startsAt : endsAt;
      if (nextChange > now) {
        this.expiryTimer = setTimeout(this.syncState, Math.min(nextChange - now, 2147483647));
      }
    }
  });
}
